import { render, staticRenderFns } from "./logwood-tag.vue?vue&type=template&id=40932414&scoped=true&"
import script from "./logwood-tag.vue?vue&type=script&lang=ts&"
export * from "./logwood-tag.vue?vue&type=script&lang=ts&"
import style0 from "./logwood-tag.vue?vue&type=style&index=0&id=40932414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40932414",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40932414')) {
      api.createRecord('40932414', component.options)
    } else {
      api.reload('40932414', component.options)
    }
    module.hot.accept("./logwood-tag.vue?vue&type=template&id=40932414&scoped=true&", function () {
      api.rerender('40932414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/logwood/views/logwood-tag.vue"
export default component.exports